import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
	FormMultiLang,
	FormMultiLangEntry,
	ReportMultiLangEntry,
} from '@evasys/globals/evainsights/models/common/multi-lang';
import { MultiLangService } from './multi-lang.service';
import { minBy } from 'lodash';

@Injectable({ providedIn: 'root' })
export class TranslocoMultiLangService extends MultiLangService {
	protected override findFormMultiLangEntry<T>(
		formMultiLang: FormMultiLang<T>
	): Observable<FormMultiLangEntry<T> | undefined> {
		// TODO: Implement in SDI-2958
		return of(formMultiLang.length > 0 ? minBy(formMultiLang, (t) => t.formLanguageId) : undefined);
	}

	protected override findReportMultiLangEntry<T>(): Observable<ReportMultiLangEntry<T> | undefined> {
		throw Error('Cannot translate report multi lang outside the context of a report');
	}
}
